import InboxRuleFolderType from '../store/schema/InboxRuleFolderType';
import store from '../store/store';

export function getFolderFromRawId(rawIdentity: string): InboxRuleFolderType {
    // the rawIdendity ends with the path to the folder, formatted **rest of rawIdentity**rootFolder:\pathToFolder
    const rawIdPath = rawIdentity.split(':\\')[1];
    let folders = store.contextMenuFolders;
    for (let folder of folders) {
        if (rawIdPath === folder.path) {
            return folder;
        }
    }
    return null;
}

export function getFolderFromFolderId(folderId: string): InboxRuleFolderType {
    // the rawIdendity ends with the path to the folder, formatted **rest of rawIdentity**rootFolder:\pathToFolder
    let folders = store.contextMenuFolders;
    for (let folder of folders) {
        if (folderId === folder.folderId) {
            // when we call this function from the create rule dialog the rawIdentity uses the folderId from the mail store
            return folder;
        }
    }
    return null;
}

export default function getFolderFromId(Id: string) {
    return Id.indexOf(':\\') > -1 ? getFolderFromRawId(Id) : getFolderFromFolderId(Id);
}
